import React, { Fragment, useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import routes from '../../../constants/routes';
import timezones from 'countries-and-timezones';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentPartner } from '../../../redux/selectors/authentication';
import { doCreateNotification } from '../../../redux/actionCreators/miscellaneous';
import { doCreateOrganisation } from '../../../redux/thunks/organisation';

import {
  emailVerification,
  phonenumberVerification,
  textVerification,
} from '../../../utils/formValdations';

// components
import TextInput from '../../../components/Inputs/TextInput';
import Dropdown from '../../../components/Inputs/Dropdown';
import PhoneInput from '../../../components/Inputs/PhoneInput';
import CountryDropdown from '../../../components/Inputs/CountryDropdown';
import { selectIsLoading } from '../../../redux/selectors/miscellaneous';
import { getCountryCode } from '../../../utils/countryCode';
import classnames from 'classnames';
import Button from '../../../components/Buttons/Button';

// styles
import style from './style.module.scss';
import styles from '../../../styles/modals.module.scss';

// Data
import ORG_TYPE_LIST from '../../../constants/list/OrganisationTypeList';
import ACCOUNT_TYPE_LIST from '../../../constants/list/AccountTypeList';
import SelectIntegrator from './SelectIntegrator';
import { Box, IconButton } from '@material-ui/core';
import SquareDelete from '../../../components/SquareDelete/SquareDelete';
import CUSTOMER_TYPE_LIST from '../../../constants/list/CustomerSetupList';
import Checkbox from '../../../components/Inputs/Checkbox/Checkbox';
import { colors } from '../../../styles/colors';
import FlexColumn from '../../../components/FlexBox/FlexColumn';
import FlexRow from '../../../components/FlexBox/FlexRow';
import SButton from '../../../components/SButton/SButton';
import Typography from '../../../components/Typography/Typography';
import useIsMobile from '../../../hooks/useIsMobile';
// import SelectIntegrator from './SelectIntegrator';
const ENV = import.meta.env.VITE_APP_ENV

const errorText = 'Please enter a valid';


const NewCustomer = () => {

  const isMobile = useIsMobile();

  const [customerName, setCustomerName] = useState({ value: '', error: '' });
  const [country, setCountry] = useState('IN');
  const [countryCode, setCountryCode] = useState('91');
  const [defaultCountryCode, setDefaultCountryCode] = useState('91');
  const [siteName, setSiteName] = useState({ value: '', error: '' });
  const [siteLocation, setSiteLocation] = useState({ value: '', error: '' });
  const [networkName, setNetworkName] = useState({ value: '', sName: '', error: '' });
  const [customerType, setCustomerType] = useState({ value: '', error: '' });
  const [accountType, setAccountType] = useState({ value: '', error: '' });
  const [customerAdminName, setcustomerAdminName] = useState({ value: '', error: '' });
  const [customerAdminEmail, setcustomerAdminEmail] = useState({ value: '', error: '' });
  const [customerAdminPhoneNumber, setcustomerAdminPhoneNumber] = useState({
    value: '',
    error: '',
  });
  const [timezone, setTimezone] = useState('');
  const [countryTimezones, setCountryTimezones] = useState([]);
  const [integrator, setIntegrator] = useState('');
  const [admins, setAdmins] = useState([
    { id: '', name: '', phone: '', email: '', adminType: 1, countryCode: defaultCountryCode },
  ]);
  const [customerSetup, setCustomerSetup] = useState({ value: 0, name: '' });
  const [credentialInheritanceType, setCredentialInheritanceType] = useState(true);


  const [adminValidationErrors, setAdminValidationErrors] = useState([{}]);
  // const [partnerAdminError, setPartnerAdminError] = useState('');

  const [showSelectIntegrator, setShowSelectIntegrator] = useState(false);

  const isLoading = useSelector(selectIsLoading);

  const dispatch = useDispatch();
  const { currentPartner } = useSelector((state) => ({
    currentPartner: selectCurrentPartner(state),
  }));

  const history = useHistory();

  const maxAdmin = 5;

  useEffect(() => {
    try {
      const code = getCountryCode();
      if (code) {
        setCountryCode(code?.countryCode);
        setDefaultCountryCode(code?.countryCode);
        setCountry(code?.userCountry?.toUpperCase());
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (country) {
      const allTimezones = timezones.getCountry(country);
      if (allTimezones?.timezones) {
        setCountryTimezones(
          allTimezones?.timezones?.map((elem, i) => {
            return { id: i, name: elem };
          }),
        );
      }
    }
  }, [country]);

  useEffect(() => {
    if (currentPartner?.integrator.length > 1) {
      setShowSelectIntegrator(true);
    } else {
      setShowSelectIntegrator(false);
      setIntegrator(currentPartner?.integrator[0]);
    }
  }, [currentPartner?.integrator]);

  const handleCreateOrganisation = useCallback(
    (payload) => {
      dispatch(
        doCreateOrganisation({
          partnerId: currentPartner?.partnerId,
          payload,
          callback: () => {
            history.push(routes.customer.list);
          },
        }),
      );
    },
    [currentPartner?.partnerId, history, dispatch],
  );

  const handleClosePopUp = () => {
    setShowSelectIntegrator(false);
  };

  const handleSubmit = () => {
    if (!integrator) {
      dispatch(
        doCreateNotification({
          isVisible: true,
          message:
            'Partner does not have an integrator. Please add an integrator before proceeding',
        }),
      );
      return false;
    }

    let adminsDetails;

    if (
      customerAdminName.value !== '' ||
      customerAdminPhoneNumber.value !== '' ||
      customerAdminEmail.value !== ''
    ) {
      adminsDetails = [
        ...admins,
        {
          name: customerAdminName.value,
          phone: customerAdminPhoneNumber?.value,
          email: customerAdminEmail.value,
          adminType: 2,
          countryCode: countryCode
        },
      ];
    } else {
      adminsDetails = admins;
    }

    const adminsDetailsWithCountryCode = adminsDetails.map((admin) => {
      // Check if the admin has a country code and phone number
      return {
        ...admin,
        phone: customerSetup?.value !== 1 ? `+${admin?.countryCode || defaultCountryCode}${admin.phone}` : undefined,
      };
    });

    const payload = {
      integratorId: integrator ? integrator?.id : 0,
      partnerId: currentPartner?.partnerId,
      name: customerName.value,
      type: customerType.value,
      accountType: accountType.value,
      country: country,
      admins: adminsDetailsWithCountryCode,
      organisationType: customerSetup?.value,
      credentialInheritanceType: credentialInheritanceType ? 0 : 1,
      sites: [
        {
          name: siteName.value,
          location: siteLocation.value,
          timezone: timezone,
          networks: [
            {
              name: networkName.value,
            },
          ],
        },
      ],
    };

    handleCreateOrganisation(payload);
  };

  const handleChange = (e) => {
    const { name, value } = e?.currentTarget;

    let error = '';
    switch (name) {
      case 'customerName':
        error = textVerification(value, 2) ? `${errorText} customer name` : '';
        setCustomerName({ value, error });
        break;
      case 'siteName':
        error = textVerification(value, 2) ? `${errorText} site name` : '';
        setSiteName({ value, error });
        break;
      case 'siteLocation':
        error = textVerification(value, 2) ? `${errorText} site location` : '';
        setSiteLocation({ value, error });
        break;
      case 'networkName':
        error = textVerification(value, 2) ? `${errorText} network name` : '';
        const nName = value.includes(siteName.value)
          ? value
          : siteName.value + ' - ' + value.slice(siteName.value.length + 1);
        if (nName.includes(siteName.value + ' - ')) {
          setNetworkName({ value: nName, error });
        } else {
          // Prevent further backspacing if siteName and '-' are not present
          setNetworkName({
            value: siteName.value + ' - ' + nName.slice(siteName.value.length + 3),
            error,
          });
        }
        break;
      case 'customerType':
        error = textVerification(customerType, 2) ? `${errorText} customer type` : '';
        setCustomerType({ value, error });
        break;
      case 'customerAdminName':
        error = (value && textVerification(value, 2)) ? `${errorText} admin name` : '';
        setcustomerAdminName({ value, error });
        break;
      case 'customerAdminEmail':
        error = (value && !emailVerification(value)) ? `${errorText} admin email` : '';
        setcustomerAdminEmail({ value, error });
        break;
      case 'customerAdminPhoneNumber':
        error = (value && !phonenumberVerification(`+${countryCode}${value}`))
          ? `${errorText} phone number`
          : '';
        setcustomerAdminPhoneNumber({ value, error });
        break;
      default:
        break;
    }
  };

  const handleValidation = (name, value, code) => {
    let error = '';
    // if (!value) return '';
    switch (name) {
      case 'name':
        error = textVerification(value, 2) ? `${errorText} admin name` : '';
        break;
      case 'email':
        error = !value ? '' : !emailVerification(value) ? `${errorText} admin email` : '';
        break;
      case 'phone':
        error = !value ? '' : !phonenumberVerification(`+${code}${value}`) ? `${errorText} phone number` : '';
        break;
      default:
        break;
    }

    return error;
  };

  const hasError = useMemo(() => {
    if (
      accountType.value === '' ||
      accountType.error !== '' ||
      customerType.value === '' ||
      customerType.error !== '' ||
      siteName.value === '' ||
      siteName.error !== '' ||
      admins.some((admin) => {
        if (!admin?.name) {
          return true;
        }

        if (customerSetup?.value === 1 && !admin?.email) {
          return true
        } else if (customerSetup?.value !== 1 && (!admin?.email || !admin?.phone)) {
          return true
        }

        return false
      }) ||
      adminValidationErrors.some(
        (admin) => {
          if (admin?.name) {
            return true;
          }

          if (customerSetup?.value === 1 && admin?.email) {
            return true;
          } else if (customerSetup?.value !== 1 && (admin?.email || admin?.phone)) {
            return true;
          }

          return false;
        },
      ) ||
      // partnerAdminError !== '' ||
      siteLocation.value === '' ||
      siteLocation.error !== '' ||
      networkName.value === '' ||
      networkName.error !== '' ||
      timezone === '' ||
      customerAdminName?.error !== '' ||
      customerAdminEmail?.error !== '' ||
      (customerSetup?.value !== 1 && customerAdminPhoneNumber?.error !== '') ||
      (
        customerSetup?.value === 1 ?
          !(customerAdminName?.value?.trim() === "" && customerAdminEmail?.value?.trim() === "") &&//ALL EMPTY
          !(customerAdminName?.value?.trim() !== "" && customerAdminEmail?.value?.trim() !== "")//ALL FIELD
          :
          !(customerAdminName?.value?.trim() === "" && customerAdminEmail?.value?.trim() === "" && customerAdminPhoneNumber?.value?.trim() === "") &&//ALL EMPTY
          !(customerAdminName?.value?.trim() !== "" && customerAdminEmail?.value?.trim() !== "" && customerAdminPhoneNumber?.value?.trim() !== "")//ALL FIELD
      ) ||//IF SOME ARE KEPT EMPTY
      !customerSetup?.value
    ) {
      return true;
    }
    return false;
  }, [
    accountType.error,
    accountType.value,
    customerType.error,
    customerType.value,
    siteLocation.error,
    siteLocation.value,
    admins,
    adminValidationErrors,
    // partnerAdminError,
    siteName.error,
    siteName.value,
    networkName.error,
    networkName.value,
    timezone,
    customerAdminEmail,
    customerAdminName,
    customerAdminPhoneNumber,
    customerSetup?.value
  ]);

  const validateAdminForm = (name, value, index, countryPhoneCode) => {
    const code = countryPhoneCode || admins[index].countryCode;

    const errorTexts = handleValidation(name, value, code);

    setAdminValidationErrors((prevErrors) => {
      const newErrors = [...prevErrors]; // Create a new array to avoid mutating the state directly
      newErrors[index] = { ...newErrors[index], [name]: errorTexts }; // Set the error message for the specific admin and field
      return newErrors;
    });
  }

  const handleMultifieldChange = (e, index) => {
    const { value, name } = e.target; // Use e.target directly instead of e.currentTarget
    validateAdminForm(name, value, index);
    // const code = admins[index].countryCode;
    // const errorTexts = handleValidation(name, value, code);

    // setAdminValidationErrors((prevErrors) => {
    //   const newErrors = [...prevErrors]; // Create a new array to avoid mutating the state directly
    //   newErrors[index] = { ...newErrors[index], [name]: errorTexts }; // Set the error message for the specific admin and field
    //   return newErrors;
    // });
    setAdmins((oldAdmins) => {
      const newAdmins = [...oldAdmins];
      newAdmins[index] = {
        ...newAdmins[index],
        [name]: value, // Update the specific field in the admin object
      };
      return newAdmins;
    });
  };

  const HandlePartnerAdminCountryCode = (code, index) => {
    setAdmins((oldAdmins) => {
      const newAdmins = [...oldAdmins];
      newAdmins[index] = {
        ...newAdmins[index],
        countryCode: code,
      };
      return newAdmins;
    });
  };

  const handleNetworkAddRemove = (type, index) => {
    if (type === 'add') {
      setAdmins((oldState) => {
        return [
          ...oldState,
          { id: '', name: '', phone: '', email: '', adminType: 1, countryCode: '91' },
        ];
      });
    } else {
      setAdmins((oldState) => {
        const newState = [...oldState];
        newState.splice(index, 1);
        return newState;
      });
      setAdminValidationErrors((oldErrors) => {
        const newErrors = [...oldErrors];
        newErrors.splice(index, 1);
        return newErrors;
      });
    }
  };

  const disableAdd = useMemo(() => {
    if (!customerName?.value ||
      customerName?.error ||
      !accountType?.value ||
      !country ||
      !customerType?.value ||
      !customerSetup?.value ||
      customerAdminEmail?.error ||
      customerAdminName?.error ||
      (customerSetup?.value !== 1 && customerAdminPhoneNumber?.error) ||
      !!admins?.find(a => !a?.name || !a?.email || (customerSetup?.value !== 1 && !a?.phone)) ||
      !!adminValidationErrors?.find(a => a?.name || a?.email || (customerSetup?.value !== 1 && a?.phone)) ||
      !siteName?.value ||
      siteName?.error ||
      !siteLocation?.value ||
      siteLocation?.error ||
      !timezone ||
      !networkName?.value ||
      networkName?.error
    ) {
      return true;
    } else {
      return false;
    }
  }, [customerName,
    country,
    accountType,
    customerType,
    customerSetup,
    admins,
    adminValidationErrors,
    customerAdminEmail,
    customerAdminName,
    customerAdminPhoneNumber,
    siteName,
    siteLocation,
    timezone,
    networkName
  ])

  return (
    <Fragment>
      <div className="spacer__0-5" />
      <div>
        {currentPartner?.integrator.length > 1 ? (
          <SelectIntegrator
            show={showSelectIntegrator}
            togglePopup={handleClosePopUp}
            list={currentPartner?.integrator}
            setIntegrator={setIntegrator}
          />
        ) : (
          <></>
        )}
        <div>
          <div className={style[`header-container`]}>
            <p className={style[`header`]}>Add Customer</p>
          </div>
          <div>
            <div className={`box ${style["nc-outer-container"]}`}>
              <FlexRow alignItems='start' justifyContent='space-around' gap='0'>
                <FlexColumn justifyContent='start' alignItems='start' width='100%' className={style['nc-inner-container']}>
                  <Typography variant={"b1SB"} color='var(--grey-700)'>Basic Details</Typography>
                  <TextInput
                    name="customerName"
                    placeholder="Customer Name"
                    onChange={handleChange}
                    disabled={isLoading}
                    error={customerName.error}
                  />
                  <Dropdown
                    name="accountType"
                    placeholder="Account Type"
                    value={accountType.value}
                    data={ACCOUNT_TYPE_LIST}
                    onChange={(data) => setAccountType({ value: data?.type, error: '' })}
                    disabled={isLoading}
                    zIndex={99}
                  />

                  <FlexRow alignItems='end'>
                    <FlexColumn styles={{ flex: "1 1 10rem" }}>
                      <CountryDropdown
                        name="country"
                        placeholder="Country"
                        value={country}
                        onChange={(value) => {
                          setCountry(value);
                          setTimezone('');
                        }}
                        fullWidth={true}
                      />
                    </FlexColumn>
                    <FlexColumn styles={{ flex: "1 1 10rem" }}>
                      <Dropdown
                        name="customerType"
                        placeholder="Customer Type"
                        value={customerType.value}
                        data={ORG_TYPE_LIST}
                        onChange={(data) => setCustomerType({ value: data?.type, error: '' })}
                        disabled={isLoading}
                        zIndex={99}
                      />
                    </FlexColumn>
                  </FlexRow>

                  <Dropdown
                    name="customerSetup"
                    placeholder="Customer Setup"
                    value={customerSetup?.name}
                    data={CUSTOMER_TYPE_LIST}
                    onChange={(data) => setCustomerSetup(data)}
                    disabled={isLoading}
                    zIndex={99}
                  />
                  {/* <FlexColumn alignItems='start' gap='0'>
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '2rem' }}>
                      <Checkbox
                        checked={credentialInheritanceType}
                        onChange={() => {
                          setCredentialInheritanceType(!credentialInheritanceType)
                        }}
                        name={"credentialInheritanceType"}
                      />
                      <p>Credential Inherited Type Organisation</p>
                    </div>
                    <Typography variant='caption' style={{ marginLeft: '2.65rem', color: colors.grey300 }}>User credentials are inherited across all access types (same credential used)</Typography>
                  </FlexColumn> */}
                  <div className={style['spacing']}></div>
                  <Typography variant={"b1SB"} color='var(--grey-700)'>Partner Admin Details</Typography>
                  <FlexRow flexWrap='nowrap' justifyContent='start'>
                    <Typography variant={"b2R"} color='var(--brand-700)'>You can add a maximum of 5 partner admins</Typography>
                    <SButton
                      disabled={admins.length === maxAdmin}
                      onClick={() => {
                        handleNetworkAddRemove('add');
                      }}
                    >Add</SButton>
                  </FlexRow>

                  <div className={style['overflowControl']}>
                    {admins.map((admin, index) => {
                      let fieldType = 1; // without add/remove
                      if (maxAdmin > 1 && index > 0) {
                        fieldType = 3; // with remove
                      } else if (maxAdmin > 1 && admins.length !== maxAdmin && index === 0) {
                        fieldType = 2; // with add
                      }
                      let field;
                      switch (fieldType) {
                        case 1:
                          field = (
                            <FlexColumn gap='0'>
                              <FlexRow justifyContent='start' alignItems='start' gap='0 1rem'>
                                <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                                  <TextInput
                                    name="name"
                                    placeholder="Partner Name"
                                    value={admin.name}
                                    onChange={(e) => handleMultifieldChange(e, index)}
                                    disabled={isLoading}
                                  // error={handleValidation('name', admin.name)}
                                  />
                                  <span style={{ color: 'red' }}>
                                    {adminValidationErrors[index]?.name}
                                  </span>
                                </FlexColumn>
                                {customerSetup?.value !== 1 && <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                                  <PhoneInput
                                    name="phone"
                                    placeholder="Partner Phone Number"
                                    type="number"
                                    defaultCountryCode={admin?.countryCode || defaultCountryCode}
                                    value={admin.phone}
                                    onChange={(e) => handleMultifieldChange(e, index)}
                                    disabled={isLoading}
                                    // error={adminPhoneNumber.error}
                                    // error={handleValidation(
                                    //   'phone',
                                    //   admin.phone,
                                    //   admin.countryCode,
                                    // )}
                                    handleCountryCode={(code) => {
                                      HandlePartnerAdminCountryCode(code, index);
                                      validateAdminForm("phone", admins[index]?.phone, index, code)
                                    }}
                                  />
                                  <span style={{ color: 'red' }}>
                                    {adminValidationErrors[index]?.phone}
                                  </span>
                                </FlexColumn>}
                              </FlexRow>
                              <FlexColumn alignItems='start' gap='0.5rem'>
                                <TextInput
                                  name="email"
                                  placeholder="Partner Email Address"
                                  type="email"
                                  value={admin.email}
                                  onChange={(e) => handleMultifieldChange(e, index)}
                                  disabled={isLoading}
                                // error={handleValidation('email', admin.email)}

                                // error={adminEmail.error}
                                />
                                <span style={{ color: 'red' }}>
                                  {adminValidationErrors[index]?.email}
                                </span>
                              </FlexColumn>
                              <div style={{ width: '100%', height: '2px', backgroundColor: 'var(--grey-300)' }} />
                            </FlexColumn>
                          );
                          break;
                        case 2:
                          field = (
                            <FlexColumn gap='0'>
                              <FlexRow alignItems='start' gap='0 1rem'>
                                <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                                  <TextInput
                                    name="name"
                                    placeholder="Partner Name"
                                    value={admin.name}
                                    onChange={(e) => handleMultifieldChange(e, index)}
                                    disabled={isLoading}
                                  // error={handleValidation('name', admin.name)}
                                  />
                                  <span style={{ color: 'red' }}>
                                    {adminValidationErrors[index]?.name}
                                  </span>
                                </FlexColumn>
                                {customerSetup?.value !== 1 && <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                                  <PhoneInput
                                    name="phone"
                                    placeholder="Partner Phone Number"
                                    type="number"
                                    defaultCountryCode={admin?.countryCode || defaultCountryCode}
                                    value={admin.phone}
                                    onChange={(e) => handleMultifieldChange(e, index)}
                                    disabled={isLoading}
                                    // error={adminPhoneNumber.error}
                                    // error={handleValidation(
                                    //   'phone',
                                    //   admin.phone,
                                    //   admin.countryCode,
                                    // )}
                                    handleCountryCode={(code) => {
                                      HandlePartnerAdminCountryCode(code, index);
                                      validateAdminForm("phone", admins[index]?.phone, index, code)
                                    }}
                                  />
                                  <span style={{ color: 'red' }}>
                                    {adminValidationErrors[index]?.phone}
                                  </span>
                                </FlexColumn>}
                              </FlexRow>
                              <FlexColumn alignItems='start' gap='0.5rem'>
                                <TextInput
                                  name="email"
                                  placeholder="Partner Email Address"
                                  type="email"
                                  value={admin.email}
                                  onChange={(e) => handleMultifieldChange(e, index)}
                                  disabled={isLoading}
                                // error={handleValidation('email', admin.email)}

                                // error={adminEmail.error}
                                />
                                <span style={{ color: 'red' }}>
                                  {adminValidationErrors[index]?.email}
                                </span>
                              </FlexColumn>
                              <div style={{ width: '100%', height: '2px', backgroundColor: 'var(--grey-300)' }} />
                            </FlexColumn>
                          );
                          break;
                        default:
                          field = (
                            <FlexColumn gap='0' alignItems='end'>
                              <FlexRow alignItems='start' gap='0 1rem'>
                                <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                                  <TextInput
                                    name="name"
                                    placeholder="Partner Name"
                                    value={admin.name}
                                    onChange={(e) => handleMultifieldChange(e, index)}
                                    disabled={isLoading}
                                  // error={handleValidation('name', admin.name)}
                                  />
                                  <span style={{ color: 'red' }}>
                                    {adminValidationErrors[index]?.name}
                                  </span>
                                </FlexColumn>
                                {customerSetup?.value !== 1 && <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                                  <PhoneInput
                                    name="phone"
                                    placeholder="Partner Phone Number"
                                    type="number"
                                    defaultCountryCode={admin?.countryCode || defaultCountryCode}
                                    value={admin.phone}
                                    onChange={(e) => handleMultifieldChange(e, index)}
                                    disabled={isLoading}
                                    // error={adminPhoneNumber.error}
                                    // error={handleValidation(
                                    //   'phone',
                                    //   admin.phone,
                                    //   admin.countryCode,
                                    // )}
                                    handleCountryCode={(code) => {
                                      HandlePartnerAdminCountryCode(code, index);
                                      validateAdminForm("phone", admins[index]?.phone, index, code)
                                    }}
                                  />
                                  <span style={{ color: 'red' }}>
                                    {adminValidationErrors[index]?.phone}
                                  </span>
                                </FlexColumn>}
                              </FlexRow>
                              <FlexColumn alignItems='start' gap='0.5rem'>
                                <TextInput
                                  name="email"
                                  placeholder="Partner Email Address"
                                  type="email"
                                  value={admin.email}
                                  onChange={(e) => handleMultifieldChange(e, index)}
                                  disabled={isLoading}
                                // error={adminEmail.error}
                                // error={handleValidation('email', admin.email)}
                                />
                                <span style={{ color: 'red' }}>
                                  {adminValidationErrors[index]?.email}
                                </span>
                              </FlexColumn>
                              <SButton
                                variant={"tertiary"}
                                onClick={() => {
                                  handleNetworkAddRemove('remove', index);
                                }}
                                style={{ margin: '0.5rem' }}
                              >
                                <SquareDelete style={{ width: '2rem', height: '2rem', padding: '0' }} />
                              </SButton>

                              <div style={{ width: '100%', height: '2px', backgroundColor: 'var(--grey-300)' }} />
                            </FlexColumn>
                          );
                          break;
                      }
                      return field;
                    })}
                  </div>
                </FlexColumn>

                <div className={style['nc-divider']} />

                <FlexColumn gap='3rem' justifyContent='start' alignItems='start' width='100%' className={style['nc-inner-container']}>
                  <FlexColumn justifyContent='start' alignItems='start' width='100%'>
                    <Typography variant={"b1SB"} color='var(--grey-700)'>Customer Super Admin Details (optional)</Typography>
                    <FlexRow alignItems='start'>
                      <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                        <TextInput
                          name="customerAdminName"
                          placeholder="Super Admin Name"
                          value={customerAdminName.value}
                          onChange={handleChange}
                          disabled={isLoading}
                          error={customerAdminName.error}
                        />
                      </FlexColumn>
                      {customerSetup?.value !== 1 && <FlexColumn alignItems='start' gap='0.5rem' styles={{ flex: "1 1 14rem" }}>
                        <PhoneInput
                          name="customerAdminPhoneNumber"
                          placeholder="Super Admin Phone Number"
                          type="number"
                          defaultCountryCode={countryCode}
                          value={customerAdminPhoneNumber.value}
                          onChange={handleChange}
                          disabled={isLoading}
                          error={customerAdminPhoneNumber.error}
                          handleCountryCode={(code) => setCountryCode(code)}
                        />
                      </FlexColumn>}
                    </FlexRow>
                    <TextInput
                      name="customerAdminEmail"
                      placeholder="Super Admin Email Address"
                      type="email"
                      value={customerAdminEmail.value}
                      onChange={handleChange}
                      disabled={isLoading}
                      error={customerAdminEmail.error}
                    />
                  </FlexColumn>
                  <FlexColumn justifyContent='start' alignItems='start' width='100%'>
                    <Typography variant={"b1SB"} color='var(--grey-700)'>Site Details</Typography>
                    <TextInput
                      name="siteName"
                      placeholder="Site Name"
                      value={siteName?.value}
                      onChange={handleChange}
                      disabled={isLoading}
                      error={siteName.error}
                    />
                    <FlexRow alignItems='start'>
                      <FlexColumn gap='0.5rem' alignItems='start' styles={{ flex: "1 1 10rem" }}>
                        <TextInput
                          name="siteLocation"
                          placeholder="Site Location"
                          value={siteLocation.value}
                          onChange={handleChange}
                          disabled={isLoading}
                          error={siteLocation.error}
                          style={{ flex: "1 1 10rem" }}
                        />
                      </FlexColumn>
                      <FlexColumn styles={{ flex: "1 1 10rem" }}>
                        <Dropdown
                          name="timezone"
                          placeholder="Site Timezone"
                          value={timezone}
                          data={countryTimezones}
                          onChange={(data) => setTimezone(data?.name)}
                        // style={{ flex: "1 1 10rem" }}
                        // zIndex={99}
                        />
                      </FlexColumn>
                    </FlexRow>
                    <TextInput
                      name="networkName"
                      placeholder="Network Name"
                      value={networkName.value}
                      onChange={handleChange}
                      disabled={isLoading}
                      error={networkName.error}
                    />
                  </FlexColumn>
                </FlexColumn>
              </FlexRow>
              <FlexRow flexWrap='nowrap' justifyContent='end' styles={{ marginTop: '3rem' }}>
                <SButton
                  fullWidth={isMobile}
                  minWidth
                  variant={"secondary"}
                  color={'grey'}
                  onClick={() => {
                    history.push(routes.customer.list);
                  }}
                >
                  Cancel
                </SButton>

                <SButton
                  fullWidth={isMobile}
                  minWidth
                  variant={"primary"}
                  color={'brand'}
                  disabled={disableAdd}
                  onClick={handleSubmit}
                >
                  Add
                </SButton>
              </FlexRow>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default NewCustomer;
